'use strict';
define(['./DataDisplayOnMap', '../../../base/PureComponent','../../../g2'], function(DataDisplayOnMap, PureComponent,g2) {
	var analysisDifferentData = PureComponent.extend({
		options: {
			title: '解析不同数据的类'
		},
		/*
		 * 初始化方法
		 * @param {Object}
		 * @param options.map 地图对象
		 * @param options.matchingLayer {Array} 必填,正则表达式匹配图层 例如：{ 'dataLayer': [/^visualize-/], 'plotLayer': [/^plot/] }
		 * */
		initialize: function(options) {
			PureComponent.prototype.initialize.call(this, options);
			this._dataDisplayOnMap = new DataDisplayOnMap(options);
			//反序列化标绘用
			this._deserializer = new g2.core.Deserializer();
			//用来记录图层id
			this.layreIds = {
				"dataLayer": [],
				"plotLayer": []
			};
			//初始化要同步的图层
			if(options.matchingLayer) {
				this._initLayerId(options.matchingLayer);
			}
		},
		/*
		 * 销毁，对应initialize
		 * */
		destroy: function() {
			//销毁展示数据到地图的类
			this._dataDisplayOnMap.destroy();
			//销毁控件
			PureComponent.prototype.destroy.call(this);
		},
		/**
		 * 初始化要同步的图层id
		 * @param {Array} matchingLayer 要匹配图层的标识数组
		 * */
		_initLayerId: function(matchingLayer) {
			var layers = this.map.getMap().getLayers();
			if(layers.length > 0) {
				for(var i = 0; i < layers.length; i++) {
					//匹配数据图层
					for(var j = 0; j < matchingLayer.dataLayer.length; j++) {
						if(matchingLayer.dataLayer[j].test(layers[i].id)) {
							this.layreIds.dataLayer.push(layers[i].id)
						}
					}
					//匹配标绘图层
					for(var j = 0; j < matchingLayer.plotLayer.length; j++) {
						if(matchingLayer.plotLayer[j].test(layers[i].id)) {
							this.layreIds.plotLayer.push(layers[i].id)
						}
					}
				}
			}
		}
	})
	/**
	 * 解析地图视野数据
	 * */
	analysisDifferentData.include({
		/**
		 * 解析地图视野数据
		 * @param {Object} options
		 * @param {Array} options.center 中心点
		 * @param {Number} options.zoomLevel 地图的缩放等级
		 * @return {String} msg 返回消息
		 * */
		analysisMapView: function(options) {
			var msg = "";
			if(options.center && options.zoomLevel) {
				var point = new g2.sfs.Point({ x: options.center[0], y: options.center[1], spatialReference: this.map.spatialReference });
				this.map.getMap().setCenter(point);
				this.map.getMap().zoomTo(options.zoomLevel);
				msg = "视野同步成功!";
			} else {
				msg = "视野同步失败!center=" + options.center + ",zoomLevel=" + options.zoomLevel;
			}
			return msg;
		}
	});
	/**
	 * 解析同步数据的数据
	 * */
	analysisDifferentData.include({
		/**
		 * 解析同步数据的数据
		 * options.memberId {String} 同步数据人的标识
		 * options.data {Object} 同步的数据
		 * @return {Object} opts 返回消息
		 * */
		analysisSyncData: function(options) {
			var msg = "";
			var dataId = "";
			var data = options.data;
			var memberId = options.memberId || options.userId;
			var mergeData = [];
			var opt = {};
			var syncDataLayer = [];
			if(memberId && data) {
				var arr = [];
				for(var key in data) {
					for(var i = 0; i < data[key].length; i++) {
						var ele = this._deserializeElement(data[key][i]);
						arr.push(ele);
					}
				}
				mergeData = mergeData.concat(arr);
				opt = {
					memberId: memberId,
					data: mergeData
				}
				try {
					dataId = this._dataDisplayOnMap.showSyncData(opt);
				} catch(e) {}
				msg = "数据解析成功!";
			} else {
				msg = "数据解析失败!成员标识或者数据不全";
			}
			var opts = {
				msg: msg,
				dataId: dataId
			}
			return opts;
		},
		/**
		 * 清除某人或者所有人的数据
		 * @param {String} memberId 需要清除数据人的标识,如果不传清除所有
		 * @return {String} msg 返回消息
		 * */
		clearSpecifyOrAllData: function(memberId) {
			var msg = "";
			this._dataDisplayOnMap.clearSpecifyOrAllData(memberId);
			if(memberId) {
				msg = memberId + "清除数据成功";
			} else {
				msg = "全部数据清除成功";
			}
			return msg;
		},
		/**
		 * 展示和隐藏某人或全部的图层
		 * @param {String} memberId 需要显隐的人的标识，如果不传显隐所有
		 * @param {Boolean} visible true显示 false隐藏
		 * @return {String} msg 返回消息
		 * */
		visibleSpecifyOrAllData: function(memberId, visible) {
			var msg = "";
			this._dataDisplayOnMap.visibleSpecifyOrAllData(memberId, visible);
			if(memberId) {
				msg = memberId + "显隐成功";
			} else {
				msg = "全部显隐成功";
			}
			return msg;
		},
		/**
		 * 根据数据id查询展示数据
		 * @param {Object} options
		 * @param {String} options.memberId 添加数据成员的标识
		 * @param {String} options.dataId 数据的id
		 * @return {String} msg 操作的消息
		 * */
		querySyncDataById: function(options) {
			this._dataDisplayOnMap.querySyncDataById(options);
		}
	});
	/**
	 * 地图上展示标绘数据
	 * */
	analysisDifferentData.include({
		/**
		 * 解析标绘数据
		 * @param {Object} options
		 * @param {String} options.memberId 同步标绘数据人的标识
		 * @param {Object} options.data 同步的标绘数据
		 * @return {Object} opts 返回消息
		 * */
		analysisSyncPlot: function(options) {
			var msg = "";
			var dataId = ""
			var mergeData = [];
			var syncPlotLayer = [];
			var memberId = options.memberId || options.userId;
			var data = options.data;
			var opt = {};
			if(memberId && data) {
				var arr = [];
				for(var key in data) {
					var arr = this._deserializePlotElement(data[key]);
					mergeData = mergeData.concat(arr);
				}
				opt = {
					memberId: memberId,
					data: mergeData
				}
				try {
					dataId = this._dataDisplayOnMap.showSyncPlot(opt);
				} catch(e) {}
				msg = "标绘数据解析成功!";
			} else {
				msg = "标绘数据解析失败!+成员标识或者数据不全"
			}
			var opts = {
				msg: msg,
				dataId: dataId
			}
			return opts;
		},
		/**
		 * 清除某人或者所有的标绘
		 * @param {String} memberId 需要清除数据人的标识,如果不传清除所有
		 * @return {String} msg 返回消息
		 * */
		clearSpecifyOrAllPlot: function(memberId) {
			var msg = "";
			this._dataDisplayOnMap.clearSpecifyOrAllPlot(memberId);
			if(memberId) {
				msg = memberId + "清除标绘成功";
			} else {
				msg = "全部标绘清除成功";
			}
			return msg;
		},
		/**
		 * 展示和隐藏某人或全部的图层
		 * @param {String} memberId 需要显隐的人的标识，如果不传显隐所有
		 * @param {Boolean} visible true显示 false隐藏
		 * @return {String} msg 返回消息
		 * */
		visibleSpecifyOrAllPlot: function(memberId, visible) {
			var msg = "";
			this._dataDisplayOnMap.visibleSpecifyOrAllPlot(memberId, visible);
			if(memberId) {
				msg = memberId + "显隐成功";
			} else {
				msg = "全部显隐成功";
			}
			return msg;
		},
		/**
		 * 根据数据id查询展示数据
		 * @param {Object} options
		 * @param {String} options.memberId 标绘数据的id
		 * @param {String} options.dataId 标绘数据的id
		 * @return {String} msg 返回消息
		 * */
		queryPlotDataById: function(options) {
			this._dataDisplayOnMap.queryPlotDataById(options);
		}
	})
	/**
	 * 内部使用方法
	 * */
	analysisDifferentData.include({
		/**
		 * 反序列化标绘元素
		 * @param {String} obj g2.plot. PlotSchema字符串对象
		 * @return {Array} elements 标绘元素数据
		 * */
		_deserializePlotElement: function(obj) {
			var elements = [];
			var schema = this._deserializer.createJsInstance(obj);
			if(!!schema) {
				for(var i = 0; i < schema.getCount(); i++) {
					var element = schema.getElement(i);
					element.reset()
					elements.push(element)
				}
			}
			return elements;
		},
		/**
		 * 反序列化数据元素
		 * @param {Object} obj 包含地图元素的参数的数据
		 * @return {g2.sfs.Element} ele 返回地图元素
		 * */
		_deserializeElement: function(obj) {
			var ele = null;
			if(obj) {
				var geom = obj.geom;
				if(geom) {
					var geometry = g2.sfs.GeometryFactory.createGeometryFromWkt(geom);
					geometry.spatialReference = obj.srid;
					var symbol = this._deserializeSymbol(obj.symbol);
					ele = new g2.sfs.Element({
						geometry: geometry,
						symbol: symbol
					});
				}
			}
			return ele;
		},
		/**
		 * 反序列化符号
		 * @param {Object} obj 包含地图元素的参数的数据
		 * @return {g2.sfs.PictureMarkerSymbol} symbol 地图元素的样式
		 */
		_deserializeSymbol: function(obj) {
			var self = this;
			if(!obj) {
				return null;
			}
			var reg = /(.*),.*/,
				groups = reg.exec(obj.$type),
				clazz = groups[1],
				symbol = null;
			switch(clazz) {
				case 'PictureMarkerSymbol':
					{
						var opts = {};
						handleNum('width,height,opacity,offsetX,offsetY,rotation', obj, opts);
						handleNotNull('source', obj, opts);
						symbol = new g2.sfs.PictureMarkerSymbol(opts);
						break;
					}
				case 'SimpleMarkerSymbol':
					{
						var opts = {};
						handleColor('fillColor,borderColor', obj, opts);
						handleNum('size,offsetX,offsetY', obj, opts);
						handleNotNull('style', obj, opts);
						symbol = new g2.sfs.SimpleMarkerSymbol(opts);
						break;
					}
				case 'TextSymbol':
					{
						var opts = {};
						handleNum('fontSize,rotation,borderThickness,offsetX,offsetY', obj, opts);
						handleColor('foreground,borderColor', obj, opts);
						handleNotNull('text,fontFamilyName,fontWeight,textAlign', obj, opts);
						symbol = new g2.sfs.TextSymbol(opts);
						break;
					}
				case 'SimpleLineSymbol':
					{
						var opts = {};
						handleColor('color', obj, opts);
						handleNum('width,style', obj, opts);
						symbol = new g2.sfs.SimpleLineSymbol(opts);
						break;
					}
				case 'SimpleFillSymbol':
					{
						var opts = {};
						handleColor('fillColor,borderColor', obj, opts);
						handleNum('borderThickness,opacity', obj, opts);
						symbol = new g2.sfs.SimpleFillSymbol(opts);
						break;
					}
				case 'CurrencySymbol':
					{
						var opts = {},
							temp = {};
						temp.fillSymbol = this.deserializeSymbol(obj.fillSymbol);
						temp.textSymbol = this.deserializeSymbol(obj.textSymbol);
						temp.markerSymbol = this.deserializeSymbol(obj.markerSymbol);
						handleNotNull('fillSymbol,textSymbol,markerSymbol', temp, opts);
						symbol = new g2.sfs.CurrencySymbol(opts);
						break;
					}
			}
			return symbol;
			//
			function handleNum(keys, src, dest) {
				var arr = keys.split(',');
				for(var i = 0, len = arr.length; i < len; i++) {
					var k = arr[i];
					if(k) {
						if(!isNaN(src[k])) {
							dest[k] = parseFloat(src[k]);
						}
					}
				}
			}
			//
			function handleNotNull(keys, src, dest) {
				var arr = keys.split(',');
				for(var i = 0, len = arr.length; i < len; i++) {
					var k = arr[i];
					if(k) {
						if(src[k]) {
							dest[k] = src[k];
						}
					}
				}
			}
			//
			function handleColor(keys, src, dest) {
				var arr = keys.split(',');
				for(var i = 0, len = arr.length; i < len; i++) {
					var k = arr[i];
					if(k) {
						var color = self._deserializeColor(src[k]);
						if(color) {
							dest[k] = color;
						}
					}
				}
			}
		},
		/**
		 * 反序列化符号
		 * @param {Object} obj  包含地图元素的参数的数据
		 * @return {Object} color 颜色对象
		 * */
		_deserializeColor: function(obj) {
			var color = new g2.sfs.Color();
			if(obj) {
				color.a = obj.a;
				color.r = obj.r;
				color.g = obj.g;
				color.b = obj.b;
			}
			return color;
		}
	})
	return analysisDifferentData;
})
